import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import {
  IBannerData,
  IConsentLetters,
  ISurgicalData,
} from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import {
  fetchConsentLetters,
  fetchSkinCancer,
  fetchSkinCancerBanner,
} from "../../api/SurgicalDomainApi";

const SkinCancer = () => {
  const { setLoading } = useLoader();
  const [skinCancerBanner, setSkinCancerBanner] = useState<IBannerData[]>([]);
  const [skinCancerData, setSkinCancerData] = useState<ISurgicalData[]>([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchSkinCancerBanner(),
      fetchSkinCancer(),
      fetchConsentLetters(),
    ])
      .then(([skinCancerBannerData, skinCancerData, consentLettersData]) => {
        setSkinCancerBanner(skinCancerBannerData);
        setSkinCancerData(skinCancerData);
        setConsentLetters(consentLettersData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={skinCancerBanner}
        page={"Skin Cancer"}
      />
      <SurgicalDomainsDescription descriptionData={skinCancerData} consentLetters={consentLetters} surgicalName='Skin_Cancer'/>
    </>
  );
};

export default SkinCancer;
